export default {
  // JavaScript to be fired on all pages
  init() {
    // Tooltips
    jQuery('[data-toggle="tooltip"]').tooltip();
    // Subheader Navigation
    function menuSlideDown() {
      jQuery(this).find('.hover-nav-container').stop().slideDown();
    }
    function menuSlideUp() {
      jQuery(this).find('.hover-nav-container').slideUp();
    }
    jQuery('#menu-subheader .menu-item').hoverIntent({over: menuSlideDown, out: menuSlideUp, timeout: 300});
    // Advanced Search
    jQuery('#property-search-more-filters').click(function() {
      var $more = jQuery('#property-search-more-filters');
      jQuery('#property-search-advanced').slideToggle('fast', function() {
        if(jQuery(this).is(":visible")) $more.text("Basic");
        else $more.text("Advanced");
      });
    });
    jQuery('#property-search-reset').click(function(e) {
      e.preventDefault();
      jQuery('form#property-search').trigger("reset");
    });
    // Mobile Search
    jQuery('#property-search-mobile').click(function() {
      var $filters = jQuery('#property-search-advanced');
      if($filters.is(":visible")) {
        $filters.slideUp('fast', function() {
          jQuery('#property-search .mobile-toggle').slideUp('fast', function() {
            jQuery(this).addClass('d-none');
          });
        });
      } else {
        jQuery('#property-search .mobile-toggle').removeClass('d-none').slideDown('fast', function() {
          $filters.slideDown('fast');
        });
      }
    });
    // Mobile Nav Select
    jQuery('.nav_select').change(function() {
      window.location.href = jQuery(this).val();
    });
    // Property Features
    jQuery('.feature-toggle').click(function(e) {
      e.preventDefault();
      var $features = jQuery(this).siblings('.row');
      if($features.is(":visible")) {
        jQuery(this).removeClass('active');
        $features.slideUp();
      } else {
        jQuery(this).addClass('active');
        $features.slideDown();
      }
    });
    // Footer submenu
    jQuery('a[href="#toggle-sub-menu"]').click(function(e) {
      e.preventDefault();
      var $features = jQuery(this).siblings('.sub-menu');
      if($features.is(":visible")) {
        jQuery(this).removeClass('active');
        $features.slideUp();
      } else {
        jQuery(this).addClass('active');
        $features.slideDown();
      }
    });
    // Auto Scroll - select all links with hashes (other than reserved)
    jQuery('a[href*="#"]').not('[href="#"]').not('[href="#carousel"]').not('[href="#toggle-sub-menu"]').click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top,
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          });
        }
      }
    });
    // Typeahead remote sources (Home Junction)
    var addressResults = new Bloodhound({
      datumTokenizer: function(datum) {
        return Bloodhound.tokenizers.whitespace(datum.label);
      },
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: '/api/addresses/%QUERY/',
        wildcard: '%QUERY',
        filter: function (response) {
          return jQuery.map(response.result.listings, function(listing) {
            var concatenatedAddress = listing.address.deliveryLine + ', ' + listing.address.city + ', ' + listing.address.state;
            listing.formattedAddress = concatenatedAddress;
            return listing;
          });
        },
      },
    });
    var cityResults = new Bloodhound({
      datumTokenizer: function(datum) {
        return Bloodhound.tokenizers.whitespace(datum.label);
      },
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: '/api/cities/%QUERY/',
        wildcard: '%QUERY',
        filter: function (response) {
          return response.result["postal-cities"];
        },
      },
    });
    // Instantiate search Typeahead
    jQuery('input[name=search]').typeahead(
      {
        highlight: true,
      },
      {
        name: 'hj-addresses',
        display: 'formattedAddress',
        source: addressResults,
      },
      {
        name: 'hj-cities',
        display: 'label',
        source: cityResults,
      }
    );
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js